import { EntityBase } from '@/bases';

export class Items extends EntityBase {
  private _Date_Required: Date = null;
  private _SLAStart: Date = null;
  private _SLAStop: Date = null;

  public Support_Group: string = null;
  public get Date_Required(): Date { return this._Date_Required; }
  public set Date_Required(value: Date) { this._Date_Required = value === null || value instanceof Date ? value : new Date(value); }
  public ContractNo: string = null;
  public LocationRef: string = null;
  public SuperCall_Id: string = null;
  public Call_Full_ref: string = null;
  public ClientName: string = null;
  public LocationName: string = null;
  public Add1: string = null;
  public Add2: string = null;
  public Add3: string = null;
  public Add4: string = null;
  public Post_Code: string = null;
  public Country: string = null;
  public Latitude: number = null;
  public Longitude: number = null;
  public PlanDate: string = null;
  public PlanConfirmed: string = null;
  public DurationMins: number = null;
  public CallType: string = null;
  public TopTen: string = null;
  public get SLAStart(): Date { return this._SLAStart; }
  public set SLAStart(value: Date) { this._SLAStart = value === null || value instanceof Date ? value : new Date(value); }
  public get SLAStop(): Date { return this._SLAStop; }
  public set SLAStop(value: Date) { this._SLAStop = value === null || value instanceof Date ? value : new Date(value); }
  public FixRule: string = null;
  public EquipmentUID: string = null;
  public Asset_Number: string = null;
  public SuperCallNumber: string = null;
  public ID: number = null;
  public Serial_Number: string = null;
  public TaskTypeID: string = null;
  public Skill: string = null;
  public contacts: string = null;
  public ItemDescription: string = null;
  public User_Ref1: string = null;
  public SkillGroup: string = null;
  public CRM_GUID: string = null;
  public SubcontractorAllowed: boolean = null;
  public InspectionType: string = null
  public ServiceEngineer: string = null;
  public SupplementaryTestingReq: string = null;

  constructor(data: any = null) {
    super();
    this.Assign(data);
  }

  public toJSON(): any {
    return {};
  }
}